import styled from "styled-components"
import background from './mountain.jpg'
export const TableContainer = styled.div`
  text-align: center;
  overflow-x:auto;
  padding-left:1em;
  padding-right:1em;
  //white-space: nowrap;
`
export const Table = styled.table`
  position: relative;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: .5em;
  text-align: center;
  z-index: 1;
  display:inline-table;
`

export const TableBody = styled.tbody`

`

export const TableRow = styled.tr`
  scroll-margin-top: 125px;
`

export const TableHeading = styled.th`
  vertical-align: middle;
  text-align: center;
  color: ${({ theme }) => theme.colors.patientFormText};
  font-size: 1.5em;
  padding: .5em .5em;
  border: 1px solid ${({ theme }) => theme.colors.patientFormBorder};
  background-color: ${({ theme }) => theme.colors.patientFormHead};

  &.sticky{
    position:sticky;
    top: 0;
    z-index:1500;
  }

  @media screen and (max-width:768px){
        font-size: 1.75em;
  }

  @media screen and (max-width:440px){
    font-size: 1.75em;
  }
`

export const Prompt = styled.td`
  border: 1px solid ${({ theme }) => theme.colors.patientFormBorder};
  color: ${({ theme }) => theme.colors.patientFormText};
  font-size: 2em;
  text-decoration: none;
  text-align: left;
  vertical-align: middle;
  padding: .5em;

  &.even{
    background-color: ${({ theme }) => theme.colors.patientFormEven};
  }

  &.odd{
    background-color: ${({ theme }) => theme.colors.patientFormOdd};
  }

  @media screen and (max-width:768px){
    font-size: 1.75em;
  }

  @media screen and (max-width:440px){
    font-size: 2.25em;
  }
`

export const Response = styled.td`
  border: 1px solid ${({ theme }) => theme.colors.patientFormBorder};
  vertical-align: middle;
  padding: 1em;
  cursor: pointer;
  &.even{
    background-color: ${({ theme }) => theme.colors.patientFormEven};
  }

  &.odd{
    background-color: ${({ theme }) => theme.colors.patientFormOdd};
  }
`

export const TextInput = styled.textarea`
  font-size: 2em;
  background: ${({ theme }) => theme.colors.patientFormTextArea};
  color: ${({ theme }) => theme.colors.patientFormText};
  padding:.25em;
  height: 2.25em;

  height: 3em;
  width: 10em;
  resize: none;

  @media screen and (max-width:440px){
    width: 6em;
  }
`

export const RadioButton = styled.input`
  @media screen and (max-width:768px){
    -ms-transform: scale(.85);
    -webkit-transform: scale(.85); 
    transform: scale(.85);
  }

  @keyframes click-wave {
    0% {
      height: 10px;
      width: 10px;
      opacity: 0.35;
      position: relative;
    }
    100% {
      height: 50px;
      width: 50px;
      margin-left: -23.75px;
      margin-top: -23.75px;
      opacity: 0;
    }
  }

  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  height: 15px;
  border-radius: 50%;
  width: 15px;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  display: inline-block;
  outline: none;
  position: relative;
  z-index: 1000;


  pointer-events: none;
  &:after{
    border-radius: 50%;
  }

  &:checked::after{
    -webkit-animation: click-wave 0.4s;
    -moz-animation: click-wave 0.4s;
    animation: click-wave 0.4s;
    background: grey;
    content: '';
    display: block;
    position: relative;
    z-index: 100;
  }

  &:checked::before{
    height: 15px;
    width: 15px;
    position: absolute;
    font-family: "Font Awesome 5 Free"; 
    font-weight: 900; 
    content: "\f00c";
    display: inline-block;
    font-size: 8px;
    text-align: center;
    line-height: 15px;
  }

  &:hover{
    background: #787878;
  }
  &:checked{
    background: #000000;
  }

  &:disabled{
    background: #787878;
  }
`

export const CheckBox = styled.input`
  @media screen and (max-width:768px){
    -ms-transform: scale(.75);
    -webkit-transform: scale(.75); 
    transform: scale(.75);
  }

  @media screen and (max-width:768px){
    -ms-transform: scale(.65);
    -webkit-transform: scale(.65); 
    transform: scale(.65);
  }

  cursor: pointer;
  @keyframes click-wave {
    0% {
      height: 10px;
      width: 10px;
      opacity: 0.35;
      position: relative;
    }
    100% {
      height: 50px;
      width: 50px;
      margin-left: -23.75px;
      margin-top: -23.75px;
      opacity: 0;
    }
  }

  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  height: 15px;
  width: 15px;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  display: inline-block;
  outline: none;
  position: relative;
  z-index: 1000;

  pointer-events: none;

  &:checked::after{
    -webkit-animation: click-wave 0.4s;
    -moz-animation: click-wave 0.4s;
    animation: click-wave 0.4s;
    background: grey;
    content: '';
    display: block;
    position: relative;
    z-index: 100;
  }

  &:checked::before{
    height: 15px;
    width: 15px;
    position: absolute;
    font-family: "Font Awesome 5 Free"; 
    font-weight: 900; 
    content: "\f00c";
    display: inline-block;
    font-size: 8px;
    text-align: center;
    line-height: 15px;
  }

  &:hover{
    background: #787878;
  }
  &:checked{
    background: #000000;
  }

  &:disabled{
    background: #787878;
  }
`

export const Information = styled.div`
  margin-top: .75em;
  font-size: 1.25em;
  color: white;
  text-align: center;

  @media screen and (max-width:768px){
    font-size: 1em;
  }

  @media screen and (max-width:440px){
    font-size: .75em;
  }
`

export const IntroductionBackground = styled.div`
  position: absolute;
  min-height: 100%;
  min-width: 200px;
  background: linear-gradient(0deg, rgba(0,0,0,0.8), rgba(0,0,0,0.8)),  url(${background}) repeat;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  z-index: 10;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  @media screen and (max-width:200px){
    background: none;
  }
`

export const ImportantText = styled.span`
  color: #02f7e3;
  //text-decoration: underline;
  font-style: italic;
`